import { useQuery } from '@tanstack/react-query';
import { useAccount } from 'wagmi';

import useGameDetails from './useGameDetails.js';
import { ZERO_ADDRESS } from 'const/index.js';

const defaultReferrer = null;


export function useUserAlreadyReferred() {
  const gameDetails = useGameDetails();
  const account = useAccount();

  const { data: alreadyReferred } = useQuery({
    queryKey: ['userAlreadyReferred', account?.address, gameDetails.contracts.referrals?._address,
      gameDetails.wantedChain.id],
    queryFn: CheckIfAlreadyReferred,
    placeholderData: false,
    refetchInterval: 0, // do not refetch
    staleTime: 5 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
  });

  async function CheckIfAlreadyReferred() {
    if (!account?.address || !gameDetails.contracts.referrals)
      return false;
    const alreadyReferred = await gameDetails.contracts.referrals.methods
      .IsAlreadyReferred(account?.address).call();
    return alreadyReferred
  }

  return alreadyReferred;
}



export function useReferrerFromBlockchain() {
  const gameDetails = useGameDetails();
  const account = useAccount();

  const { data: referrer } = useQuery({
    queryKey: ['referrer', account?.address, gameDetails.contracts.referrals?._address,
      gameDetails.wantedChain.id],
    queryFn: FetchReferrer,
    placeholderData: defaultReferrer,
    refetchInterval: 0, // do not refetch
    staleTime: 5 * 60 * 1000,
    cacheTime: 24 * 60 * 60 * 1000,
  });

  async function FetchReferrer() {
    if (!account?.address || !gameDetails.contracts.referrals)
      return defaultReferrer;
    const referrer = await gameDetails.contracts.referrals.methods.GetReferrer(account?.address).call();
    if (referrer == ZERO_ADDRESS)
      return defaultReferrer;
    return referrer;
  }

  return referrer;
};